import { Flex, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { BuyerParticipationRequestDetailDto } from "../../../../../autogen/bff-api";
import { DocumentsAsOwnerTable } from "../../../../../common/documents/DocumentsAsOwnerTable";

interface Props {
  detail: BuyerParticipationRequestDetailDto;
}

// Every evidence document across the criterion responses, deduplicated.
export const RequestDocumentsTab = ({ detail }: Props) => {
  const { t } = useTranslation();
  const documents = Array.from(
    new Map(
      (detail.request.qualificationResponses ?? [])
        .flatMap((response) => response.evidenceDocuments ?? [])
        .map((document) => [document.id, document] as const),
    ).values(),
  );

  if (documents.length === 0) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        gap="2"
        py="16"
        rounded="xl"
        bg="smBackground"
        border="1px dashed"
        borderColor="smBorder"
        color="smMuted"
      >
        <Text fontWeight="medium">{t("No documents")}</Text>
      </Flex>
    );
  }

  return (
    <Stack spacing="4">
      <DocumentsAsOwnerTable documents={documents} />
    </Stack>
  );
};
